import { Navigate, Outlet } from "react-router-dom";

export function PrivateRoute() {
  const rawAuth = localStorage.getItem("authToken");
  const auth = rawAuth ? JSON.parse(rawAuth) : null;

  // Only allow if token exists and is valid
  const isLoggedIn = auth?.AccessToken && auth?.IdToken;

  return isLoggedIn ? <Outlet /> : <Navigate to="/" replace />;
}
